import { Button, Flex, useToast } from '@chakra-ui/react';
import useToastError from 'hooks/shared/useToastError';
import FullScreenLoader from 'presentation/components/shared/FullScreenLoader';
import AlertModal from 'presentation/components/shared/modals/AlertModal';
import {
  ButtonSize, ButtonVariant,
} from 'presentation/theme/components/button';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDeleteBrokerAccountMutation } from 'rtkQuery/sharespro/queries/brokerAccounts';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  accountId: ID;
}

const DeleteBrokerAccountModal: FC<Props> = ({
  isOpen,
  onClose,
  accountId,
}) => {
  const { t } = useTranslation();

  const [deleteAccount, { isLoading: isDeleting }] =
    useDeleteBrokerAccountMutation();

    const toast = useToast();

    const toastErrorHandler = useToastError();

  return (
    <>
      <AlertModal
        title={t('attention')}
        text={t('areYouSureDeleteBrokerAccount')}
        isOpen={isOpen}
        onClose={onClose}
        footer={
          <Flex>
            <Button variant={ButtonVariant.Ghost} mr={3} size={ButtonSize.sm} onClick={onClose}>
              {t('cancelAction')}
            </Button>
            <Button
              size={ButtonSize.sm}
              onClick={() => {
                deleteAccount(accountId)
                  .unwrap()
                  .then(() => {
                    toast({
                      description: t('brokerAccountHasBeenDeleted'),
                      status: 'success',
                      position: 'top-right',
                      isClosable: true,
                    });
                    onClose();
                  })
                  .catch((err) => toastErrorHandler(err));
              }}
            >
              {t('confirm')}
            </Button>
          </Flex>
        }
      />
      <FullScreenLoader isLoading={isDeleting} />
    </>
  );
};

export default DeleteBrokerAccountModal;
